module.exports = __webpack_public_path__ + "img/banner.1b660487.jpg";